import LandingVerify from "../landing/LandingVerify";

export default function VerifyPage() {
    return <LandingVerify />;
}
